var map = {
	"./decidim/avatar-multiuser.png": 29579,
	"./decidim/brands/google.svg": 14586,
	"./decidim/cc-badge.png": 4249,
	"./decidim/decidim-logo.svg": 72921,
	"./decidim/default-avatar.svg": 20713,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 30575,
	"./decidim/icons.svg": 76328,
	"./decidim/pattern.png": 83355,
	"./decidim/placeholder-card-g.svg": 54888,
	"./decidim/placeholder-card-l.svg": 78019,
	"./decidim/placeholder.jpg": 50986,
	"./decidim/remixicon.symbol.svg": 86352,
	"./decidim/vendor/leaflet/layers-2x.png": 71369,
	"./decidim/vendor/leaflet/layers.png": 16576,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 82577,
	"./decidim/vendor/leaflet/marker-icon.png": 65304,
	"./decidim/vendor/leaflet/marker-shadow.png": 23367,
	"./decidim/vendor/social-share-button/douban.svg": 63427,
	"./decidim/vendor/social-share-button/email.svg": 65980,
	"./decidim/vendor/social-share-button/facebook.svg": 5992,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 87372,
	"./decidim/vendor/social-share-button/hacker_news.svg": 73475,
	"./decidim/vendor/social-share-button/linkedin.svg": 50266,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 93443,
	"./decidim/vendor/social-share-button/pinterest.svg": 41866,
	"./decidim/vendor/social-share-button/reddit.svg": 87136,
	"./decidim/vendor/social-share-button/telegram.svg": 13253,
	"./decidim/vendor/social-share-button/tumblr.svg": 25250,
	"./decidim/vendor/social-share-button/twitter.svg": 74521,
	"./decidim/vendor/social-share-button/vkontakte.svg": 38739,
	"./decidim/vendor/social-share-button/wechat.svg": 39774,
	"./decidim/vendor/social-share-button/whatsapp.svg": 55094,
	"./decidim/vendor/social-share-button/x.svg": 40052,
	"./decidim/vendor/social-share-button/xing.svg": 75716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31538;